var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"code-btn",class:{'invalid': _vm.codeInvalid, 'disabled': (_vm.codeInvalid||_vm.codeDisable)},attrs:{"color-primary":"","border-primary":""},on:{"click":_vm.getCode}},[_c('span',[_vm._v(_vm._s(_vm.btnText || _vm.initBtnText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }